import { render } from "./EditEventUser.vue?vue&type=template&id=f4854bba&scoped=true"
import script from "./EditEventUser.vue?vue&type=script&lang=js"
export * from "./EditEventUser.vue?vue&type=script&lang=js"

import "./EditEventUser.vue?vue&type=style&index=0&id=f4854bba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4854bba"]])

export default __exports__